import type { StitchItemSummaryDto } from '@sharedlib/dtos/dto/StitchItemSummaryDto';
import { type Board, type BoardFolder, type BoardSidebarView } from '../../types/board';
import { toBoardFolderStitchSummary } from './board-stitch-summary.util';

/** A folder as a folder list draws it: its live boards counted, and its summary for the card's bottom bar. */
export type BoardFolderRow = BoardFolder & { count: number; summary: StitchItemSummaryDto };

/**
 * The folders a folder list shows, in `folders`' order. The list follows the picked view, as the sidebar's own
 * folder rows do: Archive and Trash show their archived/trashed folders (with Restore) rather than hiding them,
 * so a folder sent there can be brought back (SV1-481 review). `search` is matched against titles, lower-cased.
 */
export function toBoardFolderRows(
  folders: readonly BoardFolder[],
  boards: readonly Board[],
  view: BoardSidebarView,
  search: string,
  accountId: string,
): BoardFolderRow[] {
  const counts = new Map<string, number>();
  for (const board of boards) {
    if (board.folderId && !board.archived && !board.deleted) counts.set(board.folderId, (counts.get(board.folderId) ?? 0) + 1);
  }
  return folders
    .filter(folder =>
      (view === 'deleted' ? folder.deleted : view === 'archived' ? folder.archived && !folder.deleted : !folder.archived && !folder.deleted) &&
      folder.title.toLocaleLowerCase().includes(search))
    .map(folder => ({ ...folder, count: counts.get(folder.id) ?? 0, summary: toBoardFolderStitchSummary(folder, accountId) }));
}
